import { AddHvacTunnelControl } from "../subcontrol/AddHvacTunnelControl";
import { AddHvacTunnelConnectControl } from "../subcontrol/AddHvacTunnelConnectControl";
import { AddHvacDeviceControl } from "../subcontrol/AddHvacDeviceControl";

/**
 * 暖通专业的二级控制器
 */
export const HVAC_SUB_CONTROL = {
    ADDHVACTUNNELCONTROL: { name: "ADDHVACTUNNELCONTROL", needInit: true, cmd: "AddHvacTunnelControl", clazz: AddHvacTunnelControl },
    ADDHVACTUNNELCONNECTCONTROL: { name: "ADDHVACTUNNELCONNECTCONTROL", needInit: true, cmd: "AddHvacTunnelConnectControl", clazz: AddHvacTunnelConnectControl },
    ADDHVACDEVICECONTROL: {name: "ADDHVACDEVICECONTROL", needInit: true, cmd: "AddHvacDeviceControl", clazz: AddHvacDeviceControl},
}